
















































import {
  Vue, Component, Prop, Watch, Mixins,
} from 'vue-property-decorator'
import firebase from 'firebase'
import { withValidation } from 'vee-validate';
import {
  sortBy, compose, toLower, includes,
} from 'ramda'
import { db } from '../../firebase/init'
import { WrittenCheckType } from '../../types'
import CDatePicker from '../inputs/CDatePicker.vue'
import MainMixin from '../../mixins/MainMixin'

const sortNoCase = sortBy(compose(toLower))

@Component({
  components: {
    CDatePicker,
  },
})
export default class WrittenCheck extends Mixins(MainMixin) {
  @Prop() title!:string

  @Prop() shifts!:any

  @Prop() users!:any

  data:WrittenCheckType = {
    user: this.$store.getters.multiUser ? '' : this.$store.getters.uid,
    date: this.justDate(),
    to: '',
    total: undefined,
    checkNumber: '',
    invoiceNumber: '',
    note: '',
  }

  get checkNames():string[] {
    if (!this.Location || !this.Location.data.checkNames) return []
    return sortNoCase(this.Location.data.checkNames)
  }

  async presubmit() {
    if (includes(this.data.to.trim(), this.checkNames)) return true
    const formCollection = db.collection('locations').doc(this.location)
    await formCollection.update({
      checkNames: firebase.firestore.FieldValue.arrayUnion(this.data.to.trim()),
    })
    return true
  }

  updateRecipient() {
    const recipient = this.data.to
    console.log('rec is: ', recipient)
    const sp = this.data.to.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
    console.log('sp is: ', sp)
    this.data.to = sp
  }

  clearForm() {
    this.data = {
      user: this.$store.getters.multiUser ? '' : this.$store.getters.uid,
      date: this.justDate(),
      to: '',
      total: undefined,
      checkNumber: '',
      invoiceNumber: '',
      note: '',
    }
    const xx:any = this.$refs.obs
    xx.reset()
  }

  created() {
    if (!this.$store.getters.multiUser) {
      this.data.user = this.$store.getters.uid
    }
  }
}

